import toast from 'react-hot-toast'

export const toastPromise = (promise, t, options = {}) =>
  toast
    .promise(promise, {
      loading: options?.loading ?? t('pending_generic'),
      success: options?.success ?? t('modal_title_success'),
      error: options?.error ?? t('modal_title_there_was_an_issue')
    })
    .catch((e) => {
      if (typeof e.response?.data?.detail === 'string') {
        toast.error(e.response.data.detail)
      } else {
        console.error(e)
      }
    })
